/**
 * Mora fora de `resolve.ts` porque o bootstrap inline é bundlado como IIFE e
 * precisa só desta função: importá-la de lá arrastava o resolutor de slug de
 * desenvolvimento, e com ele `import.meta`, ausente naquele formato de saída.
 */
export function normalizeHost(host: string) {
  return host.replace(/^www\./i, '').toLowerCase()
}
